import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigModel } from 'src/app/shared/models/ConfigModel.model';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private userToken: string;

  constructor(private http: HttpClient, private authenticationService: AuthenticationService) {
    const $this = this;
    $this.userToken = $this.authenticationService.currentUserValue.Token;
  }

  public GetConfigActive(): Observable<ConfigModel> {
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.get<ConfigModel>(environment.apiUrl + 'api/v1/Config/GetConfigActive', header).pipe();
  }

  public SaveConfig(dataToSave: ConfigModel): Observable<ConfigModel> {
    const $this = this;
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.post<ConfigModel>(environment.apiUrl + 'api/v1/Config', dataToSave, header).pipe();
  }
}
